import React from "react";

export const CameraIcon = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      <path d="M4 8.5A2.5 2.5 0 0 1 6.5 6h1.2l1.1-1.8A1.5 1.5 0 0 1 10.05 3.5h3.9a1.5 1.5 0 0 1 1.25.7L16.3 6h1.2A2.5 2.5 0 0 1 20 8.5v8A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5v-8z" />
      <circle cx="12" cy="12.5" r="3.25" />
    </svg>
  );
};
